export enum LoanReportsOrigin {
  Origination = 0,
  Servicing = 1,
}
export interface ILoanReport {
  id: number
  type: string
  origin: LoanReportsOrigin
  title: string
  filters: Record<string, any>
  placeholders: string[]
  frequency: Record<string, any>
  sendTo: Array<any>
  createdBy: string
  createdAt: Date
  access?: {
    viewAccountTypes?: string[]
    viewUsers?: string[]
    editAccountTypes?: string[]
    editUsers?: string[]
  }
  canEdit?: boolean
  canManageAccess?: boolean
}

export interface IReportHeaders {
  title: string
  data: string[]
  customTitles?: Record<string, string>
  items?: Record<string, any> // Show items for all fields
  subItems?: Record<string, any> // Show sub items for specific fields
}

export type ActionType = 'preview' | 'download' | 'downloadCSV' | 'downloadPipe'

export type DateFilterPayload = {
  column: string
  range: {
    from?: string
    to?: string
  }
}

/** Keys / labels that should allow date-range filtering (matches `extractHeaderLabel` on selected headers). */
export const isDateLikePlaceholderKey = (raw: string) => {
  const item = raw.toLowerCase()
  return (
    item.includes('date ') ||
    item.endsWith('date') ||
    item.startsWith('date') ||
    item.includes(' payment due ')
  )
}

export const getDateHeaders = (placeholders: Record<string, IReportHeaders[]>) => {
  const set = new Set<string>()
  placeholders.Loan.forEach((placeholder) => {
    const title = placeholder.title.toLowerCase()
    const addIfDate = (fieldKey: string) => {
      if (isDateLikePlaceholderKey(fieldKey) || title.includes('date')) set.add(fieldKey)
    }

    placeholder.data.forEach((_item) => addIfDate(_item))

    if (placeholder.subItems) {
      for (const items of Object.values(placeholder.subItems)) {
        if (items && typeof items === 'object' && !Array.isArray(items)) {
          for (const subKey of Object.keys(items)) addIfDate(subKey)
        }
      }
    }

    if (placeholder.items && typeof placeholder.items === 'object' && !Array.isArray(placeholder.items)) {
      for (const subKey of Object.keys(placeholder.items)) addIfDate(subKey)
    }
  })
  return Array.from(set)
}

export const ReportPlaceholdersPrefixes = {
  loanStatusDate: 'Loan Status Date',
  loanAges: 'Loan Ages',
}

export const hasPlaceholderPrefix = (title: string) => {
  if (title.startsWith('Property')) return true
  if (Object.values(ReportPlaceholdersPrefixes).includes(title)) return true
  return false
}

export const getPlaceholderValue = (title: string, value: string) => {
  if (hasPlaceholderPrefix(title)) return `${title} - ${value}`
  return value
}

export const isPlaceholderSelected = (v: string, title: string, selectedValue: string) => {
  v = getPlaceholderValue(title, v)
  return v === selectedValue
}

export const getPlaceholderFromTitle = (placeholders: IReportHeaders[], title: string) => {
  return placeholders.find((item) => item.title === title)
}

export const getItemsForField = (header: IReportHeaders, value: string): Record<string, any> | null => {
  if (header.items) return header.items
  if (header.subItems?.[value]) return header.subItems[value]
  return null
}
